import type { RootState } from '@/store/store';

export const selectPendingClientImports = (state: RootState) =>
  state.clientImportAlerts.pendingCount;
